"use strict";
// (C) 2007-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorPopInfo = exports.getPopInfo = exports.LIMIT = void 0;
var tslib_1 = require("tslib");
var isNull_1 = tslib_1.__importDefault(require("lodash/isNull"));
var format_1 = require("./format");
exports.LIMIT = 999;
function getTrend(prev, curr) {
    var previous = prev || 0;
    var current = curr || 0;
    if (previous === current) {
        return "neutral";
    }
    else if (previous < current) {
        return "up";
    }
    return "down";
}
function isTrendPositive(trend, meaning) {
    var isPositiveGrowing = trend === "up" && meaning === "growIsGood";
    var isPositiveFalling = trend === "down" && meaning === "growIsBad";
    return isPositiveGrowing || isPositiveFalling;
}
function isTrendNegative(trend, meaning) {
    var isNegativeGrowing = trend === "up" && meaning === "growIsBad";
    var isNegativeFalling = trend === "down" && meaning === "growIsGood";
    return isNegativeGrowing || isNegativeFalling;
}
function getMeaning(trend, meaning) {
    if (trend === "neutral") {
        return "neutral";
    }
    else if (isTrendPositive(trend, meaning)) {
        return "positive";
    }
    else if (isTrendNegative(trend, meaning)) {
        return "negative";
    }
    return "neutral";
}
function getPercentageValue(prev, curr) {
    if (prev === void 0) { prev = 0; }
    if (curr === void 0) { curr = 0; }
    var previous = prev || 0;
    var current = curr || 0;
    if (previous === 0 && current > 0) {
        return Number.POSITIVE_INFINITY;
    }
    else if (previous === 0 && current < 0) {
        return Number.NEGATIVE_INFINITY;
    }
    else if (previous === 0 && current === 0) {
        return 0;
    }
    var percent = Math.abs(previous / 100);
    var change = current - previous;
    return Math.round(change / percent);
}
function getPercentage(previous, current) {
    if (isNull_1.default(previous) && isNull_1.default(current)) {
        return format_1.HYPHEN;
    }
    var percentageValue = getPercentageValue(previous, current);
    var isOverLimit = percentageValue > exports.LIMIT;
    var isUnderLimit = percentageValue < -exports.LIMIT;
    if (isOverLimit) {
        return ">" + exports.LIMIT + "%";
    }
    else if (isUnderLimit) {
        return "<" + -exports.LIMIT + "%";
    }
    return percentageValue + "%";
}
function getPopInfo(previous, current, meaning) {
    var trend = getTrend(previous, current);
    var trendMeaning = getMeaning(trend, meaning);
    var percentage = getPercentage(previous, current);
    return {
        trend: trend,
        meaning: trendMeaning,
        percentage: percentage,
    };
}
exports.getPopInfo = getPopInfo;
function getErrorPopInfo() {
    return {
        trend: "neutral",
        meaning: "neutral",
        percentage: format_1.HYPHEN,
    };
}
exports.getErrorPopInfo = getErrorPopInfo;
//# sourceMappingURL=pop.js.map